<template>
  <div class="Banner">
    <img width="100%" :src="picUrl" alt="">
  </div>
</template>

<script>
  export default {
    name: "Banner",
    data() {
      return {
        picUrl: ''
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        setTimeout(()=>{
          this.$store.getters.banner.forEach((val) => {
            if (this.$route.path.indexOf(val.name) != -1) {
              this.picUrl = val.url
            }
          })
        },100)

      }
    },
    created() {
      this.$store.getters.banner.forEach((val) => {
        if (this.$route.path.indexOf(val.name) != -1) {
          this.picUrl = val.url
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/Banner.vue